import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/_layout/error/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/error/$status",
      params: { lang: params.lang, status: "500" },
      replace: true,
    });
  },
});
